import UserDetailsHA from './UserDetailsHA';

export default UserDetailsHA;
